import { ChildrenProps, ClassNameProps, makeClassName, StyleProps } from "@hex-insights/core";
import styles from "./styles.module.css";

export type BadgeProps = {
	size?: "small" | "medium" | "large";
	color?: string;
	backgroundColor?: string;
	title?: string;
} & Partial<ClassNameProps & StyleProps & ChildrenProps>;

export function Badge({ size = "medium", color, backgroundColor, title, className, style, children }: BadgeProps) {
	return (
		<div
			className={makeClassName(styles["badge"], styles[`badge--${size}`], className)}
			style={{ "--color": color, "--background-color": backgroundColor, ...style } as React.CSSProperties}
			title={title}
		>
			{children}
		</div>
	);
}

export function NewBadge({ className, children = "New", ...props }: BadgeProps) {
	return (
		<Badge {...props} className={makeClassName(styles["new-badge"], className)}>
			{children}
		</Badge>
	);
}
